import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames/bind';
import css from './AlarmListTable.module.scss';
import { getRetrieveCouponTalkdreamResultDashboardAPI } from 'redux/action/couponAction';
import { useDispatch, useSelector } from 'react-redux';
import { dateToStr, convertDateToString2 } from '@utils';

const cn = classNames.bind(css);

const AlarmListTable = ({ startDate, endDate }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const tempParams = {
      // fromDate: convertDateToString2(startDate),
      fromDate: convertDateToString2(startDate),
      toDate: convertDateToString2(endDate),
    };

    getRetrieveCouponTalkdreamResultDashboardAPI(dispatch, tempParams);
  }, [dispatch, startDate, endDate]);

  const [initialDashboardData] = useSelector(
    (state) => state.coupon.retrieveCouponTalkdreamResultDashboard
  );

  const dashboardData = useMemo(() => {
    if (initialDashboardData) {
      return { ...initialDashboardData, noDataCnt: 0 };
    } else return;
  }, [initialDashboardData]);

  const dashboardDataByType = useMemo(() => {
    const data = [
      {
        type: '고객 쿠폰 발행 완료',
        data: [
          'kakaoCouponIssueSuccessedCnt',
          'kakaoCouponIssueFailedCnt',
          'lmsCouponIssueSuccessedCnt',
          'lmsCouponIssueFailedCnt',
          'lmsCouponIssueWaitingCnt',
        ],
      },
      {
        type: '고객 폐기 알림(한 달전)',
        data: [
          'kakaoCouponExpriedNotice30SuccessedCnt',
          'kakaoCouponExpriedNotice30FailedCnt',
          'lmsCouponExpriedNotice30SuccessedCnt',
          'lmsCouponExpriedNotice30FailedCnt',
          'lmsCouponExpriedNotice30WaitingCnt',
        ],
      },
      {
        type: '고객 폐기 알림(15일전)',
        data: [
          'kakaoCouponExpriedNotice15SuccessedCnt',
          'kakaoCouponExpriedNotice15FailedCnt',
          'lmsCouponExpriedNotice15SuccessedCnt',
          'lmsCouponExpriedNotice15FailedCnt',
          'lmsCouponExpriedNotice15WaitingCnt',
        ],
      },
      {
        type: '고객 폐기 알림(1일전)',
        data: [
          'kakaoCouponExpriedNotice1SuccessedCnt',
          'kakaoCouponExpriedNotice1FailedCnt',
          'lmsCouponExpriedNotice1SuccessedCnt',
          'lmsCouponExpriedNotice1FailedCnt',
          'lmsCouponExpriedNotice1WaitingCnt',
        ],
      },
      {
        type: '제휴사 직원 난수 추가요청',
        data: [
          'noDataCnt',
          'noDataCnt',
          'lmsCouponNoCreateRequestSuccessedCnt',
          'lmsCouponNoCreateRequestFailedCnt',
          'lmsCouponNoCreateRequestWaitingCnt',
        ],
      },
    ];
    return data;
  }, []);

  const convertZeroToDash = (data) => {
    return data === 0 ? '-' : data;
  };

  return (
    <div className={cn('dataTable01', 'type04')}>
      <table>
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th rowSpan='2'>알림 구분</th>
            <th colSpan='4' className={css.bg_type02}>
              전체
            </th>
            <th colSpan='2' className={css.bg_type03}>
              알림톡
            </th>
            <th colSpan='3' className={css.bg_type04}>
              LMS
            </th>
          </tr>
          <tr>
            <th className={css.bg_type01}>발송건수</th>
            <th className={css.bg_type01}>성공</th>
            <th className={css.bg_type01}>실패</th>
            <th className={css.bg_type01}>대기중</th>
            <th className={css.bg_type01}>성공</th>
            <th className={css.bg_type01}>실패</th>
            <th className={css.bg_type01}>성공</th>
            <th className={css.bg_type01}>실패</th>
            <th className={css.bg_type01}>대기중</th>
          </tr>
        </thead>
        <tbody>
          {dashboardDataByType.map((item, index) => {
            const totalCount =
              dashboardData[item.data[0]] +
              dashboardData[item.data[1]] +
              dashboardData[item.data[2]] +
              dashboardData[item.data[3]] +
              dashboardData[item.data[4]];
            return (
              <tr key={index}>
                <td>{item.type}</td>
                <td>{convertZeroToDash(totalCount)}</td>
                <td>
                  {convertZeroToDash(
                    dashboardData[item.data[0]] + dashboardData[item.data[2]]
                  )}
                </td>
                <td>
                  {convertZeroToDash(
                    dashboardData[item.data[1]] + dashboardData[item.data[3]]
                  )}
                </td>
                <td>{convertZeroToDash(dashboardData[item.data[4]])}</td>
                <td>{convertZeroToDash(dashboardData[item.data[0]])}</td>
                <td>{convertZeroToDash(dashboardData[item.data[1]])}</td>
                <td>{convertZeroToDash(dashboardData[item.data[2]])}</td>
                <td>{convertZeroToDash(dashboardData[item.data[3]])}</td>
                <td>{convertZeroToDash(dashboardData[item.data[4]])}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AlarmListTable;
